<template>
  <div class="recommend">
    <div class="recommendTitle">推荐内容</div>
    <div class="recommendBody">
      <div class="recommendList">
        <nuxt-link :to="generateRoutes(item.id)" class="recommendItem" v-for="item in recommendedList">
          <time v-if="item.createTime">{{ dayjs(item.createTime).format('YYYY-MM-DD') }}</time>
          <div class="itemTitle">{{ item.newsTitle || item.contentTitle }}</div>
        </nuxt-link>
      </div>
<!--      <div class="backList" @click="backList">返回列表-->
<!--        <img src="~images/pages/public/backArrow.png" alt="backArrow">-->
<!--      </div>-->
    </div>
  </div>
</template>

<script setup>
import dayjs from "dayjs";

const props = defineProps({
  recommendedList: {
    // type: Array,
    required: true
  }
})

const Route = useRoute();
// const Router = useRouter();

// 生成跳转路由
function generateRoutes(id) {
  let _pathArr = Route.path.split("/");
  _pathArr[_pathArr.length - 1] = id
  let _path = `${_pathArr.join('/')}?from=${Route.query.from || ''}`
  if (Route.query.default) {
    _path += '&default='+Route.query.default
  }
  return _path
}


// 返回列表
// function backList() {
//   let _from = false
//   if (Route.query.from) {
//     _from = Route.query.from += Route.query.type ? `&type=${Route.query.type}` : ''
//     _from += Route.query.page ? `&page=${Route.query.page ? Route.query.page : 1}` : ''
//   }
//   if (_from) {
//     Router.push(_from)
//   } else {
//     let _pathArr = Route.path.split("/");
//     Router.push('/' + _pathArr[1])
//   }
// }


</script>

<style scoped lang="scss">
.recommend {
  padding-top: 64px;
  width: 236px;
  margin-left: 60px;
  flex-shrink: 0;
  .recommendTitle {
    font-size: 24px;
    color: #333333;
    display: flex;
    align-items: center;
    padding-left: 8px;
    margin-top: 28px;
    &:before {
      width: 7px;
      height: 20px;
      background: var(--main-blue-color);
      content: "";
      display: inline-block;
      margin-right: 9px;
    }
  }

  .recommendBody {
    background: #F5F5F5;
    padding: 18px 22px;
    margin-top: 12px;
    .recommendList {
      min-height: 600px;
      //width: 248px;
      .recommendItem {
        font-size: 16px;
        margin-bottom: 30px;
        display: block;
        time {
          color: var(--main-blue-color);
          line-height: 24px;
        }

        .itemTitle {
          color: var(--secondary-text-color);
          font-size: 14px;
          line-height: 22px;
        }
        &:hover {
          text-decoration: none;
        }
      }
    }
    .backList {
      padding: 0 20px;
      line-height: 40px;
      border-radius: 25px;
      background: var(--main-blue-color);
      color: var(--white);
      font-size: 16px;
      cursor: pointer;
      display: inline-block;
      margin-left: -7px;
      > img {
        width: 14px;
        height: 12px;
      }
    }
  }
}
</style>